/*
 dropdownComboBox

 Custom Knockout bindingHandler for rendering a Kendo UI dropdownlist.

 Expects the following values to be passed in:
 -- data (optional): array of data items or a function that returns an array of data items.
 -- dataPromise (optional): a function that returns a promise. 
 -- selectedIndex (optional): index of initial selected item. A value of -1 will show the placeholder.
 -- selectedValue (optional): value of initial selected item. The selectedValue property overrides selectedIndex. Empty string will show the placeholder.
 -- onChange (optional): callback function upon change. The dropdown value will be passed to the callback.
 -- textField (optional) the data field to display for each item.
 -- valueField (optional) the data field to use as the value for each item.
 -- placeHolder (optional): the text to display when no item is selected.

 */

import kendo from '@progress/kendo-ui';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';

var dropdownComboBoxHandler = {};

//Custom dropdownComboBox binding handler
ko.bindingHandlers.dropdownComboBox = dropdownComboBoxHandler = {

	update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		// This will be called once when the binding is first applied to an element,
		// and again whenever any observables/computeds that are accessed change
		// Update the DOM element based on the supplied values here.

		var props = valueAccessor();

	  //Append a div that the kendo combobox will be applied to.
		$(element).empty();
		var placeHolder = dropdownComboBoxHandler.getPlaceHolder(props);
		var $dropdownElement = $("<input style='width: 100%;' placeholder='" + placeHolder + "' />").appendTo($(element));

		var textField = ko.isObservable(props.textField) ? props.textField() : props.textField;
		var valueField = ko.isObservable(props.valueField) ? props.valueField() : props.valueField;
		var valueIsNumeric = dropdownComboBoxHandler.isValueNumeric(props);
		var dropdownDataSource = dropdownComboBoxHandler.getDataSource(props, $dropdownElement, valueField, valueIsNumeric);
		var selectConfig = dropdownComboBoxHandler.getSelectedItemConfig(props);
		var enabled = ko.isObservable(props.enabled) ? _.defaultIfNullOrUndefined(props.enabled(), true) : _.defaultIfNullOrUndefined(props.enabled, true);

		var dropdown = $dropdownElement.kendoComboBox({
			dataTextField: textField,
			dataValueField: valueField,
			dataSource: dropdownDataSource,
			filter: "contains",
      suggest: false,
			enable: enabled,
			index: selectConfig.selectedIndex,
			value: selectConfig.selectedValue,
			open: function (e) {
			  //Prevent dropdown from scrolling entire page
			  $("body").css("overflow", "hidden");
			},
			close: function (e) {
			  //Prevent dropdown from scrolling entire page
			  $("body").css("overflow", "visible");
			},
			change: function (e) {
        
			  //Convert to a string
               
			  var widget = e.sender;

			  var newValue = widget.value();

			  if (widget.value() && widget.select() === -1) {
				  widget.value("");
				  newValue = "";
				}				

			  var valueToReturn = valueIsNumeric ? newValue === "" ? -1 : _.toNumber(newValue) : newValue;

				//If the selected value is an observable, just set it with the new value
				if (ko.isObservable(props.selectedValue))
				  props.selectedValue(valueToReturn);

				//If an onChange callback was defined, call it.
				if (_.isFunction(props.onChange)) {

					var onChange = ko.isObservable(props.onChange) ? props.onChange() : props.onChange;
					var args = ko.isObservable(props.onChangeArgs) ? props.onChangeArgs() : props.onChangeArgs;
					var dataItem = this.dataItem(this.selectedIndex) || {};

					if (!_.isUndefined(args)) {
					  onChange(valueToReturn, dataItem, args)
					}
					else {
					  onChange(valueToReturn, dataItem);
					}
				}
			}
		});

    //Prevent dropdown from scrolling entire page
		$dropdownElement.data("kendoComboBox").input.on("focus", function () {
		  $("body").css("overflow", "hidden");
		});

	  //Prevent dropdown from scrolling entire page
		$dropdownElement.data("kendoComboBox").input.on("blur", function () {
		  $("body").css("overflow", "visible");
		});

	},
  //Determine if value is numeric
	isValueNumeric: function (props) {

	  var result = false;

	  //Get selected value
	  var selectedValue = ko.isObservable(props.selectedValue) ? props.selectedValue() : props.selectedValue;

	  if (!_.isNullOrUndefined(selectedValue)) {
	    result = _.isNumber(selectedValue);
	  }

	  return result;
	},
	//Return an object containing the selected item config values (selectedIndex, selectedValue)
	getSelectedItemConfig: function (props) {

		var result = {};

		//If selectedValue was defined, use it
		result.selectedValue = ko.isObservable(props.selectedValue) ? props.selectedValue() : props.selectedValue;

	  //We assume that if a value === -1, it's meant to be an Id field and that means no value selected yet,
    //so set the selected value as empty string.
		if (result.selectedValue === -1)
		  result.selectedValue = "";

		if (!_.isNullOrUndefined(result.selectedValue)) {
		  result.selectedValue = result.selectedValue.toString();
		  return result;
		}

		//Use selectedIndex. If it wasn't defined just set the index to zero.
		result.selectedIndex = ko.isObservable(props.selectedIndex) ? props.selectedIndex() : props.selectedIndex || 0;

		return result;
	},
	//Return the placeholder
	getPlaceHolder: function (props) {

		if (_.isNullOrUndefined(props.placeHolder))
			return "Select an item . . .";

		return ko.isObservable(props.placeHolder) ? props.placeHolder() : props.placeHolder;
	},
	getDataSource: function (props, $element, valueField, isValueNumeric) {

		//If a promise was passed in, create a DataSource
		if (!_.isNullOrUndefined(props.dataPromise)) {

			var dataPromise = ko.isObservable(props.dataPromise) ? props.dataPromise() : props.dataPromise;
			var args = ko.isObservable(props.args) ? props.args() : props.args;

			return new kendo.data.DataSource({
				transport: {
				  read: function (options) {

				    //Set the text to empty string temporarily until data comes back.
            //If we don't do this then the dropdown will show the value (not the text) until data does come back.
				    var dropdown = $element.data("kendoComboBox");
				    dropdown.text("");

						dataPromise.apply(null, args).then(
						  function (results) {
						    var resultsJS = ko.toJS(results);

                //Determine if our value field is numeric
						    var first = _.nth(resultsJS);
						    if (first != null && first[valueField]) {
						      var firstValue = first[valueField];
						      isValueNumeric = _.isNumber(firstValue);
						    }

						  	options.success(resultsJS);
						  },
						  function (errorResult) {
						  	options.error(errorResult);
						  });
					}
				}
			});
		}

		//Return the non-promise data source

		//Map all observable properties to JS.
		var dataResults = [];
		_.forEach(ko.isObservable(props.data) ? props.data() : props.data, function (data) {
			dataResults.push(ko.toJS(data));
		});

		return dataResults;
	}
};